import GettingStartedComponent from "../components/getting-started";

export default function GettingStarted() {
  return <GettingStartedComponent />;
}
